import ConfiguratorService from "@/services/ConfiguratorService";

export default {
    /**
     * Add intem to configurator
     * @param {*} context
     * @param {Number} typeId
     */
    addItem: function (context, typeId) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.addItem(
                context.state.configurator.uid,
                typeId
            )
                .then(function (response) {
                    context.commit("ADD_ITEM", response.data);
                    resolve()
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    addFillingItem: function (context, typeId) {
        var fillingTypeId = context.state.fillingMapping[typeId.toString()];
        return context.dispatch('addItem', fillingTypeId);
    },
    prefillItems: function (context, typeId) {
        var promise = ConfiguratorService.prefillItems(
            context.state.configurator.uid,
            typeId
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
        });
    },
    removeFillingItems: function (context, typeId) {
        var fillingTypeId = context.state.fillingMapping[typeId.toString()];
        var promise = ConfiguratorService.removeItemsByType(
            context.state.configurator.uid,
            fillingTypeId
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
        });
    },
    changeAutomaticFilling: function (context, payload) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.changeAutomaticFilling(
                context.state.configurator.uid,
                payload.productTypeId,
                payload.value
            )
                .then(function (response) {
                    context.commit("UDPATE_CONFIGURATOR", response.data);
                    resolve();
                })
                .catch(function (error) {
                    reject(error);
                })

        });
    },
    addConfiguratorItemToBasket: function (context, payload) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.addItemToBasket(
                context.state.configurator.uid,
                payload.uid,
            )
                .then(function (response) {
                    context.commit("UDPATE_CONFIGURATOR", response.data);
                    resolve();
                })
                .catch(function (error) {
                    reject(error);
                })
        });
    },
    /**
     *
     * @param {*} context
     * @param {*} payload
     */
    removeItem: function (context, payload) {
        var promise = ConfiguratorService.removeItem(
            context.state.configurator.uid,
            payload.uid
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
            context.dispatch("checkPackagings", response.data);
        });
        return promise;
    },
    removeConfiguratorItems: function (context) {
        var promise = ConfiguratorService.removeConfiguratorItems(
            context.state.configurator.uid
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
            context.dispatch("checkPackagings", response.data);
        });
    },
    changeTPValue: function (context, payload) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.changeParameter(
                context.state.configurator.uid,
                payload.uid,
                payload.values
            ).then(function (response) {
                context.commit("UDPATE_CONFIGURATOR", response.data);
                resolve(response);
            }).catch(function(error) {
                reject(error);
            });
        })
    },
    changeProductQuantity: function (context, payload) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.changeItemQuantity(
                context.state.configurator.uid,
                payload.uid,
                payload.quantity
            ).then(function (response) {
                console.log(response);
                context.commit("UDPATE_CONFIGURATOR", response.data);
                context.dispatch("checkPackagings", response.data);
                resolve(response);
            }).catch(function(error) {
                reject(error);
            });
        });
    },
    updateConfiguratorData: function (context, payload) {
        return new Promise(function (resolve, reject) {
            ConfiguratorService.updateConfiguratorData(
                context.state.configurator.uid
            )
                .then(function (response) {
                    context.commit("UDPATE_CONFIGURATOR", response.data);
                    resolve(response);
                }).catch(function (error) {
                reject(error);
            });
        });
    },
    setProductSet: function (context, payload) {
        context.commit("LOADING_CONTENT", true);
        var promise = ConfiguratorService.setProductSet(
            context.state.configurator.uid,
            payload.selectedSet
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
            context.commit("LOADING_CONTENT", false);
            context.dispatch("scrollToConfigurator");
        });
    },
    scrollToConfigurator: function (context, payload) {
        let headerHeight = $('.header').height();
        if ($('.headerPromo:visible').length > 0) {
            headerHeight += $('.headerPromo').height();
        }
        $('html, body').animate({
            scrollTop: $(".js-configurator-wrapper").offset().top - headerHeight
        }, 1000)
    },
    changePackQuantity: function (context, payload) {
        var promise = ConfiguratorService.changePackQuantity(
            context.state.configurator.uid,
            payload.collectionId,
            payload.quantity
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
            context.dispatch("checkPackagings", response.data);
        });
    },
    addConfiguratorToBasket: function (context, payload) {
        var sets = context.getters.getResumeSets.map(function (set) {
            return {
                name: set.name,
                collectionId: set.collectionId,
                collectionFixed: context.state.collectionId === set.collectionId ? context.state.collectionFixed : true,
                productSetId: set.productSet ? set.productSet.id : null,
                quantity: set.quantity,
                bedId: context.state.collectionId === set.collectionId ? context.state.configurator.bedId : null,
                bedName: context.state.collectionId === set.collectionId ? context.state.configurator.bedName : null,
                items: set.items.map(function (item) {
                    if (item.isCustom) {
                        return {
                            quantity: item.quantity,
                            isCustom: true,
                            type: item.type,
                            customParameters: item.customParameters,
                            uid: item.uid
                        };
                    } else {
                        return {
                            quantity: item.quantity,
                            variantId: item.variantInfo.variantId,
                            uid: item.uid
                        };
                    }
                })
            };
        });
        context.commit("LOADING_CONTENT", true);
        var promise = ConfiguratorService.addConfiguratorToBasket(
            context.state.configurator.uid,
            sets
        );
        promise.then(function (response) {
            context.commit("LOADING_CONTENT", false);
        });
        return promise;
    },
    changeCustomDimensions: function (context, payload) {
        var promise = ConfiguratorService.changeCustomDimensions(
            context.state.configurator.uid,
            payload.uid,
            payload.values
        );
        promise.then(function (response) {
            context.commit("UDPATE_CONFIGURATOR", response.data);
        });
    },
    checkPackagings: function (context, data) {
        if (data.packagingItemsIsSame === false) {
            popupOpen('#popup-packaging-check');
        }
    }
};
